<template>
	<div class="sk_eye_unity_user_help">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">使用说明</h1>
		<h3 class="doc_main_h3">
			概述
		</h3>
		<p class="doc_main_p">
			 该文档将详细说明如何在Unity平台上快速集成该SDK，并通过调用SDK接口使用SKEye图像识别服务。
		</p>
		<h3 class="doc_main_h3">
			系统需求
		</h3>
		<p class="doc_main_p">
			操作系统 Win7 Win8 Win10 MacOS 10.x Unity3d 64位  
			支持版本 Unity5.2.0以上 建议使用 Unity5.2.0
		</p>
		<h3 class="doc_main_h3">
			使用步骤
		</h3>
		<p class="doc_main_p">
			（1）首先安装 Unity3d,建议使用 Unity5.2.0 (64位)
		</p>
		<p class="doc_main_p">
			（2）打开 Unity3d ，新建一个工程,右键点击 Assets,选择 Import Package ,继续选择 Custom Package.选择 SKEye-Unity-SDK.unitypackgae.(注意存放 unitypackage 的路径请不 要有中文否者会导入不成功) 
		</p>
		<p class="doc_main_p">
			（3）导入package完毕后，Assets下面的结构如下：
			<img src="../../../static/images/objectRecognition/unity/1.png" class="unity_1_png">
		</p>
		<p class="doc_main_p">
			（4）选中 Assets/SKEye/Scene,文件里存放了 Vu1.0.0版本的所有 demo. WebCamera ,ImageUrl
			<img src="../../../static/images/objectRecognition/unity/2.png" class="unity_2_png">
		</p>
		<p class="doc_main_p">
			（5）双击 AllDemo,即可打开所有 Demo 的入口场景。点击开始按钮，即可运行 DEMO 程序。 效果如下
			<img src="../../../static/images/objectRecognition/unity/3.png" class="unity_1_png">
			<img src="../../../static/images/objectRecognition/unity/4.png" class="unity_2_png">
		</p>
		<p class="doc_main_p">
			（5-1）WebCamera:拍照识别，通过摄像头采集物体图像，进行精准识别。 
		</p>
		<p class="doc_main_p">
			（5-1）ImageUrl:路径识别，如果图片路径(分为网络路径与本地路径)获取图片,进行精准识 别。
		</p>
		<p class="doc_main_p">
			（6）Demo可以正常运行后，用户可参考示例实现自己的场景。方式如下： 
		</p>
		<p class="doc_main_p">
			（6-1）创建一个新的 Scene,如图：
			<img src="../../../static/images/objectRecognition/unity/5.png" class="unity_2_png">
		</p>
		<p class="doc_main_p">
			（6-2）选中 Assets/SKEye/Prefab文件夹，将 Skeye预制件拖入到场景中，如图：
			<img src="../../../static/images/objectRecognition/unity/6.png" class="unity_2_png">
		</p>
		<p class="doc_main_p">
			（6-3）点击场景中的 Skeye，查看其 Inspector面板,需要填写 Api_Key 以及 Api_secret，如 图：
			<img src="../../../static/images/objectRecognition/unity/7.png" class="unity_2_png">
		</p>
		<p class="doc_main_p">
			（6-4）点击场景中的 SKCamera,查看其 Inspector面板,在此设置前后摄像头，如图：
			<img src="../../../static/images/objectRecognition/unity/8.png" class="unity_2_png">
		</p>
		<h3 class="doc_main_h3">
			Demo说明
		</h3>
		<p class="doc_main_p">
			演示案例是Unity工程，案例展示如何调用SKEyeSDK接口，图像识别结果会在案例界面上展示，识别结果在输出界面上显示。
		</p>
		<h3 class="doc_main_h3">
			关键参数说明
		</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">api_key：String类型，指当前APP所申请的SKEye的API_KEY
api_secret：String类型，指当前APP所申请的SKEye的API_SECRET
service_name：String类型，指SKEye识别服务名称
float color_A：红色R值偏色率
float color_G：绿色G值偏色率
float bRateValue：蓝色B值偏色率
</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['物体识别','SKEye-Unity','使用说明'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../less/index.less';
	.sk_eye_unity_user_help{
		.unity_1_png{
			display: block;
			width: 200px;
			margin:20px auto;
		}
		.unity_2_png{
			display: block;
			width: 500px;
			margin:20px auto;
		}
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skeyeunity/SKEyeUserHelp.vue